<template lang="pug">
  div.image-wrapper
    v-img.mt-2.pointer(:src="getImage" :lazy-src="getImage" :class="getImageClass"  @click="onDetailImageClick")
      template( v-slot:placeholder)
        v-row.ma-0(class="fill-height ma-0" align="center" justify="center" v-if="!isSaveInProgress")
          v-progress-circular(indeterminate color="primary")
    v-progress-circular.loading-position(v-if="isSaveInProgress" indeterminate color="primary")
    template.mb-12
      v-btn.reload-button-position(v-if="getImageClass.length > 0 && !isSaveInProgress" color="green" @click="reloadSelectedImage"
          :loading="reloadLoading")
        v-icon() fa fa-sync-alt
        span {{ $t('foodDatabasePage.againSaveImage') }}
    v-btn.remove-button(type="button" fab small @click="removeSelectedImage" :loading="deleteLoading" :disabled="isSaveInProgress || reloadLoading || (disabledRemoveButtons && !deleteLoading)")
      v-icon(medium color="error") fas fa-trash

</template>

<script lang="ts">

import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {SaveNewImagePayload} from "@/types/payload";
import FoodItemImage from "@/model/food-database/FoodItemImage";
import {Action} from "vuex-class";
import {DELETE_FOOD_ITEM_IMAGE, SAVE_NEW_FOODITEM_IMAGE} from "@/store/action-types";
import FoodItem from "@/model/food-database/FoodItem";
import FoodImageModel from "@/model/food-database/FoodImageModel";

@Component({
})
export default class FoodImage extends Vue {

  @Prop({type: Number}) idx!: number
  @Prop({type: Object}) image!: FoodImageModel
  @Prop({type: Object as () => FoodItem}) selectedFood!: FoodItem
  @Prop({type: Boolean}) disabledRemoveButtons!: boolean
  @Action(SAVE_NEW_FOODITEM_IMAGE) saveNewFoodItemImage!: ({ (payload: SaveNewImagePayload | null): Promise<FoodItemImage> })
  @Action(DELETE_FOOD_ITEM_IMAGE) deleteFoodImage!: ({ (payload: any): Promise<any> })


  private isSaveInProgress: boolean = false
  private reloadLoading: boolean = false
  private deleteLoading: boolean = false

  get getImage (): string {
    if(this.image.image.includes('/api')) {
      return `${this.image.image}/data`
    } else {
      return this.image.image
    }
  }

  get getImageClass (): string {
    if(this.image.image.includes('/api')) {
      return ''
    } else {
      return 'image-shadow'
    }
  }

  onDetailImageClick(): void {
    if(this.getImageClass.length === 0 && !this.isSaveInProgress) {
      this.$emit('showDetailDialog', this.idx)
    }
  }

  async reloadSelectedImage (): Promise<void> {
    const payload: SaveNewImagePayload = {
      data: this.image.image,
      foodItem: this.selectedFood!.id.toString(),
      order: this.idx + 1
    }
    try {
      this.reloadLoading = true
      const response: FoodItemImage = await this.saveNewFoodItemImage(payload)
      this.$emit('reloadImage',this.image, response.id)
    } catch (e) {
      this.$emit('showError', this.$t('foodDatabasePage.imageSaveErrorMessage'))
    } finally {
      this.reloadLoading = false

    }
  }

  async removeSelectedImage (): Promise<void> {
    if(this.image.image.includes('/api')) {
      const payload: any = {
        id: this.image.image
      }
      try {
        this.deleteLoading = true
        this.$emit('isDeleting', true)
        await this.deleteFoodImage(payload)
        this.$emit('removeImage', this.image)
      } catch (e) {
        this.$emit('showError', this.$t('foodDatabasePage.foodItemRemoveErrorMessage'))
      } finally {
        this.deleteLoading = false
        this.$emit('isDeleting', false)
      }
    } else {
      this.$emit('removeImage', this.image)
    }
  }

  async saveNewFoodImage (): Promise<void> {
    let payload: SaveNewImagePayload = {
      data: this.image.image,
      foodItem: this.selectedFood!.id.toString(),
      order: this.idx + 1
    }
    try {
      this.isSaveInProgress = true
      const response: FoodItemImage = await this.saveNewFoodItemImage(payload)
      this.$emit('savedImage',  this.image, response.id)
    } catch (e) {
      this.$emit('showError', this.$t('foodDatabasePage.imageSaveErrorMessage'))
    } finally {
      this.isSaveInProgress = false
    }
  }

  mounted(): void {
    if(!this.image.image.includes('/api')) {
      this.saveNewFoodImage()
    }
  }
}

</script>

<style lang="stylus" scoped>

.inputFile
  display none

.image-wrapper
  height: 230px
  max-height: 230px

.loading-position
  position: absolute;
  margin-top -10px
  margin-right -10px
  top: 50%;
  right: 50%;
  z-index: 100;

.remove-button
  position: absolute;
  top: 8px;
  right: 3px;
  z-index: 100;
  background-color: darkgray;
  //padding: 4px 3px;

  color: #000;
  font-weight: bold;
  cursor: pointer;

.remove-button1
  position: absolute;
  top: 5px;
  right: 3px;
  z-index: 100;
  background-color: darkgray;
  //padding: 4px 3px;

  color: #000;
  font-weight: bold;
  cursor: pointer;
.image-shadow
  filter:grayscale(130%)

.reload-button-position
  margin-top -240px
  margin-left 22px
  z-index 200

.reload-button-position2
  margin-top -240px
  margin-left 5px
  z-index 200

.pointer
  cursor pointer
</style>